import {IAttributes, IAugmentedJQuery, IDirective, IScope} from "angular";
import c3 from "c3";

require("./c3Graf.scss");


export function c3GrafForInjisering() {
    return [c3Graf];
}

function c3Graf(): IDirective {

    return {
        restrict: 'EAC',
        scope: {
            config: '='
        },
        template: '<div></div>',
        replace: true,
        link: function ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes) {
            $scope.$watch("config", (konfig: any) => {
                if (!konfig) return;
                konfig.bindto = '#' + $attr["id"];
                //dersom c3Graf vises på side som initielt lastes vises ikke alltid svg-elementet korrekt
                //det virker som om beregningene gjort av c3.generate er sensitive for om dom-en er fullstendig lastet
                //legger derfor tegningen av grafen inn i en timeout slik at dom er ferdig tegnet før graf legges til
                //dette problemet oppleves kun i chrome..
                window.setTimeout(() => {
                    var chart = c3.generate(konfig);
                }, 1)

            })
        }
    };
}